<!------------------------------Title------------------------------>
<qr-topbar
  title="Panel Interno"
  [isDropdownOfficeVisible]="false"
  [isFixedOnScrollUp]="false"
></qr-topbar>

<!------------------------------Main Content------------------------------>
<div id="panel-container">
  <!----------Office Information---------->
  <p id="selectedOfficeInfo" class="heading-01-semi-bold">
    Oficina seleccionada
    <span class="heading-01-bold">{{ user.agency_name }}</span>
  </p>

  <!----------Office Selection---------->
  <form id="buttonsContainer">
    <qr-input-autocomplete
      (selectedChange)="officeSelected($event)"
      [config]="inputAutocompleteString"
    >
    </qr-input-autocomplete>
  </form>

  <!----------General Office Stats Table---------->
  <app-stats-table></app-stats-table>
</div>
